import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const profilStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatarStyle: {
      backgroundColor: "#f5f6f8",
    },
    items: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingTop: "5px",
      color: "#399ebf",
      fontSize: "15px",
      fontWeight: "bold",
    },
    checkbox: {
      paddingRight: "12px",
      "& MuiCheckbox-root": {
        margin: "0px",
      },
    },
    userGrid: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "6px",
    },
    companyName: {
      color: "#f2994a",
      fontWeight: 500,
      marginTop: "12px",
      fontSize: "12px",
    },
    userInfos: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingTop: "5px",
    },
    menuList: {
      "& .MuiMenuItem-root": {
        lineHeight: 0.5,
        paddingTop: "1px",
        paddingBottom: "1px",
      },
    },
  })
);
